import React from "react";
import { ReportsTab } from "../components/Reports/ReportsTab";
export const Reports = () => {
  return <ReportsTab />;
};
